import * as React from "react"
import PropTypes from "prop-types"

const getAbsoluteImageUrl = (url, siteBaseUrl) => {
  if (!url) {
    return "";
  }

  if (url.startsWith("//")) {
    return `https:${url}`;
  }

  if (url.startsWith("/")) {
    return `${siteBaseUrl}${url}`;
  }

  return url;
}

const Seo = ({
  siteUrl,
  url,
  name,
  defaultLocale,
  titleTemplate,
  title,
  image,
  description,
  lang,
  keywords,
  ogtype,
  twittercard,
  tools,
  ratingJson,
}) => {
  const siteBaseUrl = siteUrl.replace(/\/+$/, "")
  const canonicalPath = url === "/" ? url : `${url.replace(/\/+$/, "")}/`
  const canonicalUrl = `${siteBaseUrl}${canonicalPath}`
  const imageUrl = getAbsoluteImageUrl(image?.file?.url, siteBaseUrl)
  const hasBrandName = name && title.toLowerCase().includes(name.toLowerCase())
  const ogTitle = titleTemplate && name && !hasBrandName ? `${title} - ${name}` : title

  return (
    <>
      <html dir="ltr" lang={lang || defaultLocale || undefined} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      {imageUrl ? <meta property="og:image" content={imageUrl} /> : null}
      {image?.file?.details?.image?.width ? (
        <meta property="og:image:width" content={image.file.details.image.width} />
      ) : null}
      {image?.file?.details?.image?.height ? (
        <meta property="og:image:height" content={image.file.details.image.height} />
      ) : null}
      {imageUrl ? <meta name="twitter:image:src" content={imageUrl} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {ogtype ? <meta property="og:type" content={ogtype} /> : null}
      {twittercard ? <meta name="twitter:card" content={twittercard} /> : null}
      <link rel="canonical" href={canonicalUrl} />
      <link rel="manifest" href="/manifest.json" />
      <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      {tools?.split("</script>\n")?.map((tool, i) => {
        if (tool?.length > 1) {
          /* eslint-disable react/no-array-index-key */
          return (
            <script key={i} type="text/javascript">
              {tool.replace("<script>", "").replace("</script>", "")}
            </script>
          )
        }
        return null
      }) || null}
      {ratingJson ? (
        <script type="application/ld+json">{`${ratingJson}`}</script>
      ) : null}
    </>
  )
}

Seo.propTypes = {
  url: PropTypes.string.isRequired,
  titleTemplate: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.exact({
    file: PropTypes.exact({
      details: PropTypes.exact({
        image: PropTypes.exact({
          height: PropTypes.number,
          width: PropTypes.number,
        }),
      }),
      url: PropTypes.string,
    }),
  }),
  siteUrl: PropTypes.string,
  lang: PropTypes.string,
  keywords: PropTypes.string,
  ogtype: PropTypes.string,
  twittercard: PropTypes.string,
  name: PropTypes.string,
  defaultLocale: PropTypes.string,
  tools: PropTypes.string,
  ratingJson: PropTypes.string,
}

Seo.defaultProps = {
  siteUrl: "",
  lang: "",
  keywords: "",
  ogtype: "",
  twittercard: "",
  name: "",
  defaultLocale: "",
  image: null,
  tools: "",
  ratingJson: null,
}

export default Seo
